import Widget from './classes/widget';

if (!window._FUTURI_WIDGET) {
  // This should only run once, so _FUTURI_WIDGET will prevent any other widget embed scripts the station may have placed on the page from executing this again
  window._FUTURI_WIDGET = true;
  // What we'll push the widget objects into once they're instantiated
  window.FUTURI_WIDGETS = [];
  // old style script elements whose source has a query string (for legacy widget support, should only be one or none)
  const scriptElementsWithQuery = [].slice.call(document.querySelectorAll('script[src*="futuri-post-widget"]'))
    .filter(el => !!el.src.split(/\?/)[1]);

  // old style placeholder (should be one or none, so we try to grab the first one)
  const anchorElementWithId = document.getElementById('futuri-widget');

  // convert old style embed code to new style
  if (scriptElementsWithQuery[0]) {
    const config = scriptElementsWithQuery[0].src.split(/\?/)[1];
    // if there's an old style placeholder element, convert it to new style
    if (anchorElementWithId) {
      anchorElementWithId.classList.add('futuri-widget');
      anchorElementWithId.dataset.config = config;
    // no placeholder element exists, so create one
    } else {
      const newAnchorElement = document.createElement('div');
      newAnchorElement.classList.add('futuri-widget');
      newAnchorElement.dataset.config = config;
      const parentNode = scriptElementsWithQuery[0].parentNode;
      parentNode.insertBefore(newAnchorElement, scriptElementsWithQuery[0]);
    }
  }

  // new style placeholders for support of multiple widgets on a single page
  const anchorElementsWithClass = [].slice.call(document.getElementsByClassName('futuri-widget'))
    .filter(el => !!el.dataset.config);

  // Push the class instance into the array
  anchorElementsWithClass.forEach(el => {
    const uuid = 'xxxxxxxxxxx'.replace(/x/g, () => Math.floor(Math.random() * 10));
    window.FUTURI_WIDGETS.push(new Widget(el, uuid));
  });

  // Loop through and setup each widget if it hasn't already been executed
  window.FUTURI_WIDGETS.forEach((widget) => {
    if (!widget.hasExecuted) {
      widget.setupWidget();
    }
  });
}



// WEBPACK FOOTER //
// ./src/embedder.js